
    
            <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
                <f-icon icon-config='{"iconName": "arrows-rotate", "iconType": "solid", "iconSize": "s"}'></f-icon>
            </button>
            <div class="card-content">
                <h6 class="cp-heading">My Appointments</h6>
                <section *ngIf="appointmentsCardService.isDbMyApppointmentsErrorEnabled" class="error-wrapper">
                    <f-alert variant="warning">
                        <p *ngIf="appointmentsCardService.hasNoDbMyApppointmentsData">
                            No Scheduler tool has been configured for this client.
                        </p>
                        <p *ngIf="!appointmentsCardService.hasNoDbMyApppointmentsData">
                            We can’t connect to Scheduler tool right now, please try again
                            later. If the error continues, contact myIT.
                        </p>
                    </f-alert>
                </section>
                <div class="content">
                    <p class="content-text" *ngIf="!appointmentsCardService.isDbMyApppointmentsErrorEnabled">
                        You may have upcoming appointments. Click below to review.
                    </p>
                    <ul class="no-margin wrap-content">
                        <li *ngFor="let appointment of appointmentsCardService.dashboardMyAppointmentsData">
                            <f-button [iconConfig]="iconConfig" class="ih-view-btn"
                                text="Go to {{ appointment.heading }}" title="Go to {{ appointment.heading }}"
                                type="button" variant="action" (click)="goToMyAppointments(appointment)">
                            </f-button>

                        </li>
                    </ul>
                </div>
            </div>

            <app-loader *ngIf="appointmentsCardService.dbMyApppointmentsLoader" [loaderType]="loaderType"
                [loaderMsg]="appointmentsCardService.showDbMyApppointmentsLoaderMsg"></app-loader>
        
